import { axios } from '@Root/API'

export const create = payload => {
  return axios.post('upload/applications/attachment', payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}
